export class ErrorSessionNotFound extends Error {}
export class ErrorRequestConstructor extends Error {}
